import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from "./home/home.component";
import { ListComponent } from "./list/list.component";
import { DetailComponent } from "./detail/detail.component";
import { AboutComponent } from "./about/about.component";
import { ServicesComponent } from "./services/services.component";
import { NewsComponent } from "./news/news.component";
import { NewsdetailComponent } from "./newsdetail/newsdetail.component";
import { PrivacyComponent } from "./privacy/privacy.component";
import { ContactComponent } from "./contact/contact.component";

export const appRoutes: Routes = [
    { path: 'home',             component: HomeComponent    },
    { path: 'list',             component: ListComponent    },   
    { path: 'detail/:id',       component: DetailComponent  },       
    { path: 'about',            component: AboutComponent   },
    { path: 'services',         component: ServicesComponent},
    { path: 'news',             component: NewsComponent    },
    { path: 'newsdetail/:id',   component: NewsdetailComponent},
    { path: 'privacy',          component: PrivacyComponent },
    { path: 'contact',          component: ContactComponent },
   
    { path: '', redirectTo: '/home', pathMatch: 'full' },
];


// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/app.routing.ts